export default {
  '个人信息':'个人信息',
  '修改密码':'修改密码',
  '姓名：':'姓名：',
  '手机号：':'手机号：',
  '修改信息':'修改信息',
  '姓 名':'姓 名',
  '请输入':'请输入',
  '当前密码':'当前密码',
  '新密码':'新密码',
  '确认密码':'确认密码',
  '取 消':'取 消',
  '取消':'取消',
  '确 定':'确 定',
  '确定':'确定',
  '接口出错':'接口出错',
  '请输入姓名':'请输入姓名',
  '请输入完整信息':'请输入完整信息',
  '两次输入的密码不一致':'两次输入的密码不一致',
  '修改成功':'修改成功',
  '修改成功,请重新登录':'修改成功,请重新登录',
}